import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '../styles/globals.css';
import App from './App';
import { AppErrorBoundary } from './AppErrorBoundary';
import { initPostHog } from '../shared/analytics/posthog';
import { handlePreloadError } from './preload-error';

// Recover from stale chunks after a deploy. A browser holding an older index
// references chunk hashes that 404 once a new build ships, so a lazy-route
// import fails ("Failed to fetch dynamically imported module"). Reload once to
// pull the fresh index + chunks. The sessionStorage guard stops a reload loop
// if reloading doesn't resolve it (e.g. genuinely offline).
window.addEventListener('vite:preloadError', handlePreloadError);

// Before the first render, so a crash on load is reported by the boundaries
// rather than dropped while PostHog is still uninitialized.
initPostHog();

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootEl).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>
);
